import JobGroup from './JobGroup'

export default JobGroup
